import { Button } from '@nazka/nazka.mapframe.components';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import { MAX_IMAGE_SIZE } from '@App/app.constants';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './image-upload-field.styl';

function ImageUploadField({
  fieldName = 'image',
  id = 'image-upload',
  imageError,
  imageFile,
  register,
  resetField,
  setImageError,
  setImageFile,
}) {
  const { t } = useTranslation();
  const handleImageChange = (e) => {
    const [file] = e.target.files;
    if (!file) {
      return;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      setImageError('Image size should be less than 10MB.');
      return;
    }

    setImageError(null);
    setImageFile(file);
  };

  const handleClearImage = () => {
    setImageFile(null);
    setImageError(null);
    resetField(fieldName);
  };

  return (
    <div className="image-upload-field">
      <label htmlFor={id} className="image-upload-field__label">
        {t('Image')}
      </label>
      <input
        className="image-upload-field__input"
        type="file"
        id={id}
        accept="image/png, image/jpeg, image/jpg"
        name={fieldName}
        {...register(fieldName, {
          onChange: handleImageChange,
        })}
      />
      <div className="image-upload-field__upload-label-wrapper">
        <label htmlFor={id} className="image-upload-field__upload-btn">
          {t('Upload')}
        </label>
        {imageFile && (
          <div className="image-upload-field__upload-label-indicator">
            <span>{imageFile?.name}</span>
            <Button
              icon={faTrash}
              layout="outlined"
              onClick={handleClearImage}
              css={{
                borderRadius: '50%',
                color: '#dc3545',
                borderColor: '#dc3545',
                '&:hover': {
                  color: 'white',
                  backgroundColor: '#dc3545',
                  borderColor: '#dc3545',
                },
              }}
            />
          </div>
        )}
      </div>
      {imageError && (
        <p className="image-upload-field__error">{t(imageError)}</p>
      )}
    </div>
  );
}

export default ImageUploadField;
